const SENSITIVE_PARAMS = [
  'access_token',
  'refresh_token',
  'id_token',
  'client_secret',
  'code',
  'state',
  'token',
  'assertion',
  'client_assertion',
  'password',
  'secret',
  'api_key',
  'apikey',
];

const REDACTED = '*REDACTED*';

function isSensitiveParam(paramName: string): boolean {
  const lowerParam = paramName.toLowerCase();
  return SENSITIVE_PARAMS.some((sensitive) => lowerParam === sensitive);
}

function isUrl(value: string): boolean {
  try {
    void new URL(value);
    return true;
  } catch {
    return false;
  }
}

export function redactUrl(url: string): string {
  try {
    const urlObj = new URL(url);

    const paramsToRedact: string[] = [];
    urlObj.searchParams.forEach((_, key) => {
      if (isSensitiveParam(key)) {
        paramsToRedact.push(key);
      }
    });
    paramsToRedact.forEach((param) => {
      urlObj.searchParams.set(param, REDACTED);
    });

    const urlValuedParams: string[] = [];
    urlObj.searchParams.forEach((value, key) => {
      if (isUrl(value)) {
        urlValuedParams.push(key);
      }
    });
    urlValuedParams.forEach((param) => {
      urlObj.searchParams.set(param, REDACTED);
    });

    if (urlObj.hash && urlObj.hash.includes('=')) {
      const hashParams = new URLSearchParams(urlObj.hash.slice(1));
      const redactedHash = new URLSearchParams();
      hashParams.forEach((_, key) => {
        redactedHash.set(key, REDACTED);
      });
      urlObj.hash = `#${redactedHash.toString()}`;
    }

    return urlObj.toString();
  } catch {
    return REDACTED;
  }
}
